import React, { useState, useEffect } from "react";
import adminClasses from "../../../landing-pages/admin/admin.module.css";
import IdNameModel from "../../../../models/common/IdNameModel";
import AdminInterviewsModel from "../../../../models/admin/interviews/response/AdminInterviewsModel";
import PagedListModel from "../../../../models/common/PagedListModel";
import dateTimeUtils from "../../../../utils/date-utils";
import AdminInterviewsSearchInputModel from "../../../../models/admin/interviews/request/AdminInterviewsSearchInputModel";
import { SortDirection } from "../../../../models/enums/SortDirectionEnum";
import adminInterviewsService from "../../../../services/admin/admin-interviews-service";
import { GeneralPoupConfig, ModalSize } from "../../../../models/modal-types";
import modalUtils from "../../../../utils/modal-utils";
import toasterUtils from "../../../../utils/toaster-utils";
import InterviewsGridComponent from "./InterviewsGridComponent";
import UpdateInterviewRequestModel from "../../../../models/admin/interviews/request/UpdateInterviewRequestModel";
import UpdateInterviewPopUp from "./UpdateInterviewComponent";
import adminDashboardService from "../../../../services/admin/admin-dashboard-service";
import RatingDetailsPopUp from "../../../candidate/dashboard/RatingDetailsComponent";
import loaderUtils from "../../../../utils/loader-utils";
import masterDataService from "../../../../services/master-data-service";
import { PagingEnum } from "../../../../models/enums/IAIEnum";
import CanidateStatusRequestModel from "../../../../models/admin/candidate/request/CanidateStatusRequestModel";
import TodayFollowupUpdateComponent from "../../candidate/today-followups/TodayFollowupUpdateComponent";
import adminCandidateService from "../../../../services/admin/admin-candidate-service";
import { GuidEnum } from "../../../../models/enums/GuidEnum";
import CandidateHistoryComponent from "../../../admin/candidate/candidate-history/CandidateHistoryComponent";
import ConfirmInterviewComponent from "../../../interviewer/dashboard/ConfirmInterviewComponent";
import { Autocomplete, Button, Checkbox, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import Clear from "@mui/icons-material/Clear";
import Search from "@mui/icons-material/Search";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import fileUtils from "../../../../utils/file-utils";

interface InterviewsProps {
    primarySkillsList: IdNameModel[];
    timeSlotsList: IdNameModel[];
    interviewerList: IdNameModel[];
    cityList: IdNameModel[];
    statusList: IdNameModel[];
};

const InterviewsComponent = (props: InterviewsProps) => {
    const [interviewerList, setInterviewerList] = useState<IdNameModel[]>(props.interviewerList);
    const [candidatePagedList, setCandidatePagedList] = useState<PagedListModel<AdminInterviewsModel>>();
    const [candidateList, setCandidateList] = useState<AdminInterviewsModel[]>([]);
    const [refreshCandidate, setRefreshCandidate] = useState<number>(2);
    const [startDateSearch, setStartDateSearch] = useState<Dayjs | null>(dayjs());
    const [endDateSearch, setEndDateSearch] = useState<Dayjs | null>(dayjs());
    const [primarySKillSearch, setPrimarySkillSearch] = useState<number>(0);
    const [interviewerSearch, setInterviewerSearch] = useState<string>(GuidEnum.Empty);
    const [citySearch, setCitySearch] = useState<number>(0);
    const [registeredCandidatesSearch, setRegisteredCandidatesSearch] = useState<boolean>(false);
    const [ratedCandidatesSearch, setRatedCandidatesSearch] = useState<boolean>(false);
    const [totalRating, setTotalRating] = useState<string>("");
    const [nameFilter, setNameFilter] = useState<string>("");
    const [companyNameFilter, setCompanyFilter] = useState<string>("");
    const [page, setPage] = useState<number>(PagingEnum.page);
    const [pageSize, setPageSize] = useState<number>(PagingEnum.pageSize);
    const [sortColumn, setSortColumn] = useState<string>("CandidateName");
    const [sortDirection, setSortDirection] = useState<number>(PagingEnum.sortDirection);
    const [pageSizesList, setPageSizesList] = useState<number[]>([]);

    useEffect(() => {
        loadPageSizes();
        clearSearch();
        getCandidates(getSearchFilters(nameFilter, companyNameFilter, totalRating, page, pageSize, sortColumn, sortDirection), true)
    }, []);

    const loadInterviewers = (primarySkillId: number) => {
        setPrimarySkillSearch(primarySkillId);
        adminInterviewsService.getInterviewersByPrimarySkill(primarySkillId, GuidEnum.Empty).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setInterviewerList(res.items);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Interviewers");
        });
    }

    const loadPageSizes = () => {
        masterDataService.loadPageSizesForPaging().then((res) => {
            setPageSizesList(res);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getSearchFilters = (nameFilter: string, companyNameFilter: string, totalRating: string, page: number, pageSize: number, sortColumn: string, sortDirection: number) => {
        var inputData: AdminInterviewsSearchInputModel = {
            startDate: dateTimeUtils.getFormattedDate(startDateSearch ? startDateSearch.toDate() : new Date()),
            endDate: dateTimeUtils.getFormattedDate(endDateSearch ? endDateSearch.toDate() : new Date()),
            primarySkillId: primarySKillSearch,
            interviewerId: interviewerSearch === "" || interviewerSearch === GuidEnum.Empty ? null : interviewerSearch,
            cityId: citySearch,
            registeredCandidates: registeredCandidatesSearch,
            ratedCandidates: ratedCandidatesSearch,
            name: nameFilter,
            totalRating: totalRating === "" ? null : totalRating,
            companyName: companyNameFilter,
            page: page,
            pageSize: pageSize,
            sort: sortColumn,
            sortDir: sortDirection
        };
        return inputData;
    };

    const getCandidates = (inputData: AdminInterviewsSearchInputModel, showloader: boolean) => {
        setRefreshCandidate(2);
        if (showloader) {
            modalUtils.showLoader();
        }
        adminInterviewsService.getInterviews(inputData).then((res) => {
            modalUtils.closeModal();
            setCandidateList([]);
            setCandidatePagedList(res);
            setCandidateList(res.items);
            setRefreshCandidate(refreshCandidate * 5);
        }).catch((error) => {
            setRefreshCandidate(refreshCandidate * 5);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const clearSearch = () => {
        setCandidateList([]);
        setStartDateSearch(dayjs());
        setEndDateSearch(dayjs());
        setPrimarySkillSearch(0);
        setInterviewerSearch("");
        setCitySearch(0);
        setRefreshCandidate(2);
    };

    const onUpdateInterviewActionHandler = (objInterview: UpdateInterviewRequestModel, primarySkillId: number) => {
        modalUtils.showLoader();
        let dateString: string = dateTimeUtils.getFormattedDate(objInterview.interviewDate);
        adminInterviewsService.getInterviewersByPrimarySkillForViewInterviews(primarySkillId, objInterview.interviewId, dateString).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            const config: GeneralPoupConfig = {
                title: "ReSchedule Interview",
                content: (
                    <UpdateInterviewPopUp
                        objInterview={objInterview}
                        interviewerList={res.items.length > 0 ? res.items : []}
                        timeSlotList={props.timeSlotsList}
                        primarySkillId={primarySkillId}
                        onRescheduleInterviewAction={onRescheduleInterviewActionHandler}
                        onCloseUpdateInterview={onCloseUpdateInterviewActionHandler}
                    />
                ),
                size: ModalSize.LG,
                className: "model-min-height-500"
            };
            modalUtils.showPopup(config);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const onCloseUpdateInterviewActionHandler = () => {
        modalUtils.closeModal();
    };

    const onRescheduleInterviewActionHandler = (objInterview: UpdateInterviewRequestModel) => {
        modalUtils.showLoader();
        adminInterviewsService.updateInterview(objInterview).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            getCandidates(getSearchFilters(nameFilter, companyNameFilter, totalRating, page, pageSize, sortColumn, sortDirection), true);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const onViewRatingActionHandler = (interviewId: string) => {
        modalUtils.showLoader();
        adminDashboardService.interviewRatingDetails(interviewId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            if (res.isSuccess) {
                const config: GeneralPoupConfig = {
                    title: "Feedback Report",
                    content: (
                        <RatingDetailsPopUp objRatingDetails={res.data} />
                    ),
                    size: ModalSize.XL,
                    className: "model-rating-details-badge"
                };
                modalUtils.showPopup(config);
            } else {
                toasterUtils.showError(res.errorMessages.toString());
            }
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError("Eror fetching Schedules");
        });
    };

    const handleRegisteredCandidatesSearch = (): void => {
        setRegisteredCandidatesSearch(!registeredCandidatesSearch);
    };

    const handleRatedCandidatesSearch = (): void => {
        setRatedCandidatesSearch(!ratedCandidatesSearch);
    };

    const onUpdateFollowupActionHandler = (candidateId: string) => {
        modalUtils.showLoader();
        adminCandidateService.getCandidateStatus(candidateId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            let objCandidate: CanidateStatusRequestModel;
            if (res.data !== null) {
                objCandidate = res.data
            } else {
                objCandidate = {
                    candidateId: candidateId,
                    statusId: 0,
                    comments: "",
                    followUpDate: new Date,
                    profileId: null,
                    userId: GuidEnum.Empty
                };
            }
            const config: GeneralPoupConfig = {
                title: "update Status",
                content: (
                    <TodayFollowupUpdateComponent
                        objCandidate={objCandidate}
                        statusList={props.statusList}
                        onFollowupClose={onFollowupCloseHandler}
                        onFollowupUpdate={onFollowUpUpdateHandler}
                    />
                ),
                size: ModalSize.LG,
                className: "model-min-height-500"
            };
            modalUtils.showPopup(config);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const onCandidateViewHistoryHandler = (candidateId: string) => {
        const config: GeneralPoupConfig = {
            title: "Candidate History",
            content: (
                <CandidateHistoryComponent
                    candidateId={candidateId} />
            ),
            size: ModalSize.XL,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    const onFollowupCloseHandler = () => {
        modalUtils.closeModal();
    };

    const onFollowUpUpdateHandler = (objCandidate: CanidateStatusRequestModel) => {
        setRefreshCandidate(2);
        modalUtils.showLoader();
        adminCandidateService.saveCandidateStatus(objCandidate).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            getCandidates(getSearchFilters(nameFilter, companyNameFilter, totalRating, page, pageSize, sortColumn, sortDirection), true)
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const onPageChangeActionHandler = (newPage: number) => {
        setPage(newPage);
        getCandidates(getSearchFilters(nameFilter, companyNameFilter, totalRating, newPage, pageSize, sortColumn, sortDirection), true);
    };

    const onPageSizeChangeActionHandler = (newPageSize: number) => {
        setPageSize(newPageSize);
        setPage(PagingEnum.page);
        getCandidates(getSearchFilters(nameFilter, companyNameFilter, totalRating, PagingEnum.page, newPageSize, sortColumn, sortDirection), true);
    };

    const onSortActionHandler = (newSortColumn: string, sortDir: string) => {
        setSortColumn(newSortColumn);
        setSortDirection(sortDir === "asc" ? SortDirection.Asc : SortDirection.Desc);
        getCandidates(getSearchFilters(nameFilter, companyNameFilter, totalRating, page, pageSize, newSortColumn, sortDir === "asc" ? SortDirection.Asc : SortDirection.Desc), true);
    };

    const onFilterActionHandler = (filterColumn: string, filterValue: string) => {
        setPage(0);
        if (filterColumn === "CandidateName") {
            setNameFilter(filterValue);
            getCandidates(getSearchFilters(filterValue, companyNameFilter, totalRating, 0, pageSize, sortColumn, sortDirection), false);
        } else {
            setCompanyFilter(filterValue);
            getCandidates(getSearchFilters(nameFilter, filterValue, totalRating, 0, pageSize, sortColumn, sortDirection), false);
        }
    };

    const onViewInterviewActionHandler = (interview: AdminInterviewsModel) => {
        const config: GeneralPoupConfig = {
            title: "Interview Details",
            content: (
                <ConfirmInterviewComponent
                    interviewId={interview.interviewId}
                    candidateId={interview.candidateId}
                    resumeTitle=""
                    isConfirmedByInterviewer="True"
                    onConfirmInterview={confirmInterviewHandler}
                />
            ),
            size: ModalSize.XL,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    const confirmInterviewHandler = (interviewId: string) => {
        modalUtils.closeModal();
    };

    const getInterviewsExport = (inputData: AdminInterviewsSearchInputModel) => {
        modalUtils.showLoader();
        adminInterviewsService.getInterviewsExport(inputData).then((res) => {
            modalUtils.closeModal();
            fileUtils.downloadFile(res, "Interviews.xlsx");
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    return (
        <>
            <div className="card card-white">
                <div className="card-head">
                    <IconButton
                        title="Export to Excel"
                        onClick={() =>
                            getInterviewsExport(
                                getSearchFilters(nameFilter, companyNameFilter, totalRating, page, pageSize, sortColumn, sortDirection)
                            )
                        }
                        sx={{
                            color: "#217346", // Excel green
                            ml: 1,
                            fontSize: 22,
                        }}
                    >
                        <FileDownloadIcon fontSize="inherit" />
                    </IconButton>
                    <div className="apply-filter" style={{ display: "inline", float: "right" }}>
                        Filter Interviews <i className="fas fa-filter" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"></i>
                    </div>
                    <div className="offcanvas offcanvas-end" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                        <div className="offcanvas-header">
                            <h5 className="offcanvas-title" id="offcanvasRightLabel">Apply Filter</h5>
                            <a type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></a>
                        </div>
                        <div className="offcanvas-body">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Start Date"
                                            value={startDateSearch}
                                            onChange={(newValue) => setStartDateSearch(newValue)}
                                            format="YYYY-MMM-DD"
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true,
                                                    size: "small",
                                                    margin: "normal",
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="End Date"
                                            value={endDateSearch}
                                            onChange={(newValue) => setEndDateSearch(newValue)}
                                            format="YYYY-MMM-DD"
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true,
                                                    size: "small",
                                                    margin: "normal",
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth margin="normal" size="small">
                                        <Autocomplete options={props.primarySkillsList} value={props.primarySkillsList.find((x) => x.id === primarySKillSearch) || null}
                                            onChange={(_, newValue) => loadInterviewers(newValue ? newValue.id : 0)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.id === value.id}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Primary Skill" size="small" margin="normal" fullWidth />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth margin="none" size="small">
                                        <Autocomplete options={interviewerList} value={interviewerList.find((x) => x.guId === interviewerSearch) || null}
                                            onChange={(_, newValue) => setInterviewerSearch(newValue ? newValue.guId : GuidEnum.Empty)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.guId === value.guId}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Interviewer" size="small" margin="normal" fullWidth />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth margin="none" size="small">
                                        <Autocomplete options={props.cityList} value={props.cityList.find((x) => x.id === citySearch) || null}
                                            onChange={(_, newValue) => setCitySearch(newValue ? newValue.id : 0)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.id === value.id}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Location" size="small" margin="normal" fullWidth />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={registeredCandidatesSearch} onChange={handleRegisteredCandidatesSearch} color="primary" />
                                        }
                                        label="Registered Candidates"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={ratedCandidatesSearch} onChange={handleRatedCandidatesSearch} color="primary" />
                                        }
                                        label="Rated Candidates"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <Button variant="contained" color="success" onClick={() => getCandidates(getSearchFilters(nameFilter, companyNameFilter, totalRating, page, pageSize, sortColumn, sortDirection), true)}
                                        startIcon={<Search />} sx={{ mt: 2, ml: 2 }}>
                                        Search
                                    </Button>
                                    <Button variant="contained" color="warning" onClick={() => clearSearch()} startIcon={<Clear />} sx={{ mt: 2, ml: 2 }}>
                                        Clear
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    {refreshCandidate > 2 &&
                        <InterviewsGridComponent
                            key={refreshCandidate}
                            candidateList={candidateList}
                            totalSize={candidatePagedList?.totalCount ? candidatePagedList?.totalCount : candidateList.length}
                            currentPage={page + 1}
                            pagesize={pageSize}
                            sortColumn={sortColumn}
                            sortDirection={sortDirection === SortDirection.Asc ? "asc" : "desc"}
                            pageSizesList={pageSizesList}
                            nameFilterValue={nameFilter}
                            companyNameFilterValue={companyNameFilter}
                            onUpdateInterviewAction={onUpdateInterviewActionHandler}
                            onViewInterviewAction={onViewInterviewActionHandler}
                            onViewRatingAction={onViewRatingActionHandler}
                            onUpdateFollowupAction={onUpdateFollowupActionHandler}
                            onCandidateViewHistory={onCandidateViewHistoryHandler}
                            onPageChangeAction={onPageChangeActionHandler}
                            onPageSizeChangeAction={onPageSizeChangeActionHandler}
                            onSortAction={onSortActionHandler}
                            onFilterAction={onFilterActionHandler}
                        />
                    }
                </div>
            </div>
        </>
    );
};
export default InterviewsComponent;